import { render, staticRenderFns } from "./Realization.vue?vue&type=template&id=53c97516&scoped=true&"
import script from "./Realization.vue?vue&type=script&lang=js&"
export * from "./Realization.vue?vue&type=script&lang=js&"
import style0 from "./Realization.vue?vue&type=style&index=0&id=53c97516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c97516",
  null
  
)

export default component.exports